import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Package } from '../models/Package';
import { BaseService } from '../../../../../../shared/services/base.service';
import { LocalStorageKeysEnum } from '../../../../../../shared/models/localStorageKeys-enum';
import { environment } from '../../../../../../environments/environment';
import { ApiResponse } from '../../../../../../common/models/api-response';
import { localStorageGetItem } from '../../../../../../shared/utils/safe-storage';

@Injectable({
  providedIn: 'root'
})
export class PackageService extends BaseService {
  public authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  constructor(private http:HttpClient) {
    super();
  }
  getPackages(){
    
    const isTokenExist:string | null= localStorageGetItem(this.authLocalStorageToken);
    var route=`${this.baseUrl}/${isTokenExist ?'packages-with-auth': 'packages'}`;
    
    return this.http.get<Package[]>(route);
  }
  create(packages: Package) {
    const route = `${this.baseUrl}/package`;
    return this.http.post<ApiResponse<Package>>(route, packages);
  }
    update(packages: Package){
    var route = `${this.baseUrl}/package`;
    return this.http.put<ApiResponse<Package>>(route, packages);
  }

  requestRefund(userPackageId:string,productId:string){
    const route = `${this.baseUrl}/requestRefund?userPackageId=${userPackageId}&productId=${productId}`;
    return this.http.get<string>(route);
  }
}
